import { render } from "./PainelRootView.vue?vue&type=template&id=a8b2a5da&scoped=true"
import script from "./PainelRootView.vue?vue&type=script&lang=js"
export * from "./PainelRootView.vue?vue&type=script&lang=js"

import "./PainelRootView.vue?vue&type=style&index=0&id=a8b2a5da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b2a5da"]])

export default __exports__